import React, { useContext, useEffect } from "react";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Divider, useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import SaitButton from "./SaitButton";
import { checkOpen } from "../utils/SaitUtils";
import { BUTTON_UPLOAD } from "../utils/ButtonTypes";
import SaitButtonUpload from "./SaitButtonUpload";
import { defaultAppBarHeight, defaultOpenDrawerWidth, ModuleContext } from "../utils/Constants";

export default function SaitDialog(props) {
	const menuOpen = useSelector((state) => state["generalConfig"]["menuOpen"]);
	const autofocus = useSelector((state) => state["generalConfig"]["searchTextClicked"]);
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

	const componentModule = useContext(ModuleContext);

	const module = useSelector((state) => state["module"]["module"]);
	const [visible, setVisible] = React.useState(true);

	useEffect(() => {
		if (module === componentModule) {
			setVisible(true);
		} else {
			setVisible(false);
		}
	}, [module]);

	const titleTextAlign = props.titleTextAlign === "left" ? "flex-start" : "center";

	return (
		<Dialog
			fullScreen={props.fullScreen || fullScreen}
			fullWidth={true}
			onClose={props.onClose}
			maxWidth={props.width}
			open={checkOpen(props.open)}
			scroll={props.scroll}
			sx={{
				display: visible ? "initial" : "none",
				marginTop: `${window["Configs"].appBarHeight || defaultAppBarHeight}px`,
				marginLeft: menuOpen ? `${window["Configs"].openDrawerWidth || defaultOpenDrawerWidth}px` : window["Configs"].showClosedDrawer ? `64px` : `0px`,
			}}
			disableEnforceFocus={autofocus}
		>
			<DialogTitle
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: titleTextAlign,
					padding: "8px 16px",
					position: "relative",
				}}
			>
				<Box
					sx={{
						fontWeight: "bold",
						fontSize: "1rem",
						color: props.titleColor,
					}}
				>
					{props.title}
				</Box>

				{props.topButtons && (
					<Box
						sx={{
							position: "absolute",
							right: 16,
							display: "flex",
							gap: 1,
						}}
					>
						{props.topButtons && (
							<Box sx={{ display: "flex", gap: 1, marginLeft: 2 }}>
								{props.topButtons.map((button, index) => {
									switch (button.type) {
										case BUTTON_UPLOAD:
											return (
												<SaitButtonUpload
													key={index}
													text={button.text}
													onUpload={button.onUpload}
													variant={button.variant || "text"}
													disabled={button.disabled}
													multiple={button.multiple}
													accept={button.accept}
													objmod={button.objmod}
												/>
											);
										default:
											return (
												<SaitButton
													key={index}
													text={button.text}
													onClick={button.function}
													endIcon={button.icon}
													variant={button.variant || "text"}
													sx={button.sx || {}}
													color={button.color || "primary"}
													disabled={button.disabled || false}
													objmod={button.objmod}
												/>
											);
									}
								})}
							</Box>
						)}
					</Box>
				)}
			</DialogTitle>
			{props.stepper ? props.stepper : <Divider />}
			<DialogContent
				sx={{
					margin: "1px",
					minHeight: props.minHeight || 50,
					display: "flex",
					flexDirection: "column",
					pl: 1,
					pr: 1,
					pt: 1,
					pb: 0,
				}}
			>
				{checkOpen(props.open) && props.content}
			</DialogContent>
			<DialogActions style={{ display: "flex", justifyContent: "space-between" }}>{props.actions}</DialogActions>
		</Dialog>
	);
}
